export enum MODULE_NAME {
	GENERAL = "General",
	DASHBOARD = "Dashboard",
	USERS = "Users",
	PARTICIPANTS = "Participants",
}
